import a from "react";
import s from "classnames";
import { T as u } from "./index-BB-Wk85r.es.js";
import { u as h } from "./DarkModeProvider-xoZXm3ct.es.js";
import './Title2.css';const v = "Title-module__nextToIcon___JRGDq", k = "Title-module__headerSpacer___smIHi", x = "Title-module__lineClamp___TwSDX", y = "Title-module__title___Tm-Ef", E = "Title-module__dark___esxbK", I = "Title-module__hovered___9sBF7", e = {
  nextToIcon: v,
  headerSpacer: k,
  lineClamp: x,
  title: y,
  dark: E,
  hovered: I
}, N = ({
  children: i,
  maxLines: l,
  nextToIcon: m = !1,
  addHeaderSpacer: d = !1,
  tagName: c = "h3",
  onClick: t,
  href: o,
  openInNewTab: p = !1,
  isHovered: f = !1
}) => {
  const T = h();
  let r = i;
  if (t || o) {
    let n = typeof t == "string" ? t : "";
    o && (n = o), r = /* @__PURE__ */ a.createElement(
      "a",
      {
        href: n,
        target: p ? "_blank" : void 0,
        onClick: (_) => {
          _.stopPropagation(), typeof t == "function" && (_.preventDefault(), t());
        }
      },
      r
    );
  }
  return /* @__PURE__ */ a.createElement(
    "div",
    {
      className: s([
        m && e.nextToIcon,
        d && e.headerSpacer
      ])
    },
    /* @__PURE__ */ a.createElement(
      u.Heading3,
      {
        responsive: !0,
        tagName: c,
        className: s([
          e.title,
          f && e.hovered,
          T && e.dark
        ])
      },
      /* @__PURE__ */ a.createElement(
        "span",
        {
          className: s(l && e.lineClamp),
          style: l ? { WebkitLineClamp: l } : {}
        },
        r
      )
    )
  );
};
N.displayName = "Title";
export {
  N as T
};
